import Vue from "vue";
import App from "@/App.vue";
import i18n from "@/lang/lang.js";

Vue.config.productionTip = false;

let areStartScriptsLoaded = false;

Vue.mixin({
  data: () => {
    return {
      isMobile: false,
      pratkowiecka: false
    };
  },
  methods: {
    nodeListToArray(nodeList) {
      return Array.prototype.slice.call(nodeList);
    },
    setFavicon(faviconName) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${window.location.origin}/${faviconName}`;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
    setPratkowiecka() {
        const windowLocationOrHash = window.location.hash !== '' ? window.location.hash : window.location.origin;
        if ( windowLocationOrHash.includes('pratkowieckalech') ) {
            this.pratkowiecka = false;
        } else {
            this.pratkowiecka = true;
        }
    },
    setIsMobile() {
      const setIsMobile = () => {
        this.isMobile = window.innerWidth < 1020;
      };
     
      setIsMobile();
      window.addEventListener("resize", setIsMobile);
    }
  }
});

new Vue({
  i18n,
  render: h => h(App)
}).$mount("#app");
